export default "__VITE_ASSET__xZuK3DFs__"